export default __webpack_public_path__ + "static/media/share-icon.6558d65a.svg";